'use strict';

var React = require('react');

const ChipContext = /*#__PURE__*/ React.createContext(null);
/**
 * Hook to use chip context
 *
 * @scope Web, Internal
 */ const useChipContext = ()=>{
    const context = React.useContext(ChipContext);
    if (!context) {
        throw new Error("Chip.Item must be used within a Chip");
    }
    return context;
};

exports.ChipContext = ChipContext;
exports.useChipContext = useChipContext;
//# sourceMappingURL=ChipContext.cjs.map
